import Container from 'react-bootstrap/Container';
import React from 'react';
import styled from 'styled-components';
import brmLogoUrl from '../assets/brm-logo.svg';

const StyledImg = styled.img`
  height: 60px;
  @media (max-width: 576px) {
    height: 45px;
  }
`;

const Header = ({ children }) => (
  <header className="bg-white">
    <Container className="py-3 d-flex">
      <div className="flex-grow-1 d-flex align-items-center">
        <StyledImg alt="Brm Logo" src={brmLogoUrl} />
      </div>
      <div>
        {children}
      </div>
    </Container>
  </header>
);

export default Header;
